module.exports = __webpack_public_path__ + "static/img/de-Pender-Elena.6c44dc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/nl/de-Pender-Elena.jpg
// module id = dktz
// module chunks = 1